export default "__VITE_ASSET__2c31a06d__"